/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './confirmEmail.defs.js'
export * as $defs from './confirmEmail.defs.js'
